package com.partejar.app.core.session

import com.russhwolf.settings.Settings

interface BiometricPreferences {
    fun isEnabled(): Boolean
    fun isOfferHandled(): Boolean
    fun setEnabled(enabled: Boolean)
    fun markOfferHandled()
    fun clear()
}

class SettingsBiometricPreferences(
    private val settings: Settings
) : BiometricPreferences {
    override fun isEnabled(): Boolean = settings.getBoolean(BIOMETRIC_ENABLED, false)
    override fun isOfferHandled(): Boolean = settings.getBoolean(BIOMETRIC_OFFER_HANDLED, false)
    override fun setEnabled(enabled: Boolean) = settings.putBoolean(BIOMETRIC_ENABLED, enabled)
    override fun markOfferHandled() = settings.putBoolean(BIOMETRIC_OFFER_HANDLED, true)

    override fun clear() {
        settings.remove(BIOMETRIC_ENABLED)
        settings.remove(BIOMETRIC_OFFER_HANDLED)
    }

    private companion object {
        const val BIOMETRIC_ENABLED = "security.biometric_enabled"
        const val BIOMETRIC_OFFER_HANDLED = "security.biometric_offer_handled"
    }
}
